import { useState } from 'react'

import { ManagementHeader, ManagementViewSelectButton } from '@apps-common/apps/portal/pages/management/components'
import {
  NonAllocatedSimInfiniteView,
  NonAllocatedSimModal,
  NonAllocatedSimTableView
} from '@apps-common/apps/portal/pages/management/components/non-allocated-sim'
import { RootHeaderButtons } from '@apps-common/components/common'
import { NavbarCompanyLogo } from '@apps-common/components/common/logos'
import { MobileViewSwitcher } from '@apps-common/components/common/MobileViewSwitcher'
import { ButtonRoundSm } from '@apps-common/components/elements'
import { ControlledInputDebounced } from '@apps-common/components/elements/form'
import { Header } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { Navbar } from '@apps-common/components/navigation'
import { commonIcons } from '@apps-common/config/icons'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'

export const NonAllocatedSimView = () => {
  const [searchVal, setSearchVal] = useState('')

  return (
    <>
      <Header>
        <Navbar transparent startComponents={<NavbarCompanyLogo />} icons={<RootHeaderButtons />} />

        <ManagementHeader
          search={
            <div className='flex items-center justify-start gap-2 relative mt-2'>
              <ModalButton
                component={NonAllocatedSimModal}
                enterAnimation={modalSlideUpEnterAnimation}
                leaveAnimation={modalSlideUpLeaveAnimation}
              >
                <ButtonRoundSm type='div' className='action-success' disabled={searchVal.length === 0} callback={() => setSearchVal('')}>
                  <commonIcons.importFile />
                </ButtonRoundSm>
              </ModalButton>
              <ControlledInputDebounced
                type='text'
                placeholder='Start typing to search...'
                label='Search'
                id='contactSearch'
                containerClassName='grow sm:grow-0 sm:min-w-[260px]'
                hideErrors
                value={searchVal}
                onChange={(e: any) => setSearchVal(e?.target?.value || '')}
              />
              <ButtonRoundSm
                type='button'
                className='action-brand-solid'
                disabled={searchVal.length === 0}
                callback={() => setSearchVal('')}
              >
                <commonIcons.close className='text-[1.4em]' />
              </ButtonRoundSm>
              <ManagementViewSelectButton />
            </div>
          }
        />
      </Header>
      <MobileViewSwitcher
        desktopView={<NonAllocatedSimTableView searchVal={searchVal} />}
        mobileView={<NonAllocatedSimInfiniteView searchVal={searchVal} />}
      />
    </>
  )
}
